import React, { useEffect, useState } from 'react';
import CaptureStripeHeader from './CaptureStripeHeader';
import { EIGHT_METER_FOULS, EIGHT_METER_FOUL_UNKNOWN, EightMeterFoul } from '../../../config/Constants';

interface EightMeterFoulModalProps {
  open: boolean;
  submitting?: boolean;
  onConfirm: (fouls: EightMeterFoul[]) => void;
  onClose: () => void;
}

const EightMeterFoulModal: React.FC<EightMeterFoulModalProps> = ({
  open,
  submitting = false,
  onConfirm,
  onClose,
}) => {
  const [selected, setSelected] = useState<EightMeterFoul[]>([]);

  useEffect(() => {
    if (open) setSelected([]);
  }, [open]);

  if (!open) return null;

  const toggle = (foul: EightMeterFoul) => {
    if (submitting) return;
    setSelected((prev) => {
      if (prev.includes(foul)) return prev.filter((f) => f !== foul);
      if (foul === EIGHT_METER_FOUL_UNKNOWN) return [foul];
      return [...prev.filter((f) => f !== EIGHT_METER_FOUL_UNKNOWN), foul];
    });
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-5"
      onClick={() => !submitting && onClose()}
    >
      <div className="w-full max-w-md bg-white shadow-xl overflow-hidden" onClick={(event) => event.stopPropagation()}>
        <CaptureStripeHeader tone="yellow" title="8M FOUL" />
        <div className="px-6 pt-6 pb-8">
          <p className="text-center text-xl font-semibold text-sd-ink mb-6">What was the foul?</p>
          <div className="flex flex-col gap-3">
            {EIGHT_METER_FOULS.map(({ value, label }) => {
              const checked = selected.includes(value);
              return (
                <button
                  key={value}
                  type="button"
                  className={`flex items-center gap-3 rounded-md border-2 px-4 py-3 text-lg font-semibold text-left transition-colors ${
                    checked ? 'border-yellow-400 bg-[#fff59d] text-black' : 'border-sd-line bg-white text-sd-ink'
                  }`}
                  onClick={() => toggle(value)}
                  aria-pressed={checked}
                >
                  <span
                    className={`w-6 h-6 rounded border-2 flex items-center justify-center ${
                      checked ? 'border-sd-ink bg-sd-ink text-white' : 'border-sd-line'
                    }`}
                  >
                    {checked ? '✓' : ''}
                  </span>
                  {label}
                </button>
              );
            })}
          </div>
          <div className="flex gap-4 mt-8">
            <button
              type="button"
              className="flex-1 rounded-md border border-sd-line py-3 text-lg font-semibold text-sd-ink"
              onClick={onClose}
              disabled={submitting}
            >
              Cancel
            </button>
            <button
              type="button"
              className="flex-1 rounded-md bg-sd-dark py-3 text-lg font-bold text-white shadow disabled:opacity-50"
              onClick={() => onConfirm(selected)}
              disabled={submitting || selected.length === 0}
            >
              {submitting ? 'Saving...' : 'Confirm'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EightMeterFoulModal;
